import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="w-full border-b border-background-200 bg-background-100">
      <ol className="mx-auto flex w-full flex-wrap items-center gap-2 px-4 py-4 text-xs text-foreground-500 md:px-8 md:text-sm">
        {items.map((item, i) => (
          <li key={`${item.label}-${i}`} className="flex items-center gap-2">
            {item.to ? (
              <Link to={item.to} className="cursor-pointer transition-colors hover:text-primary-600">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800">{item.label}</span>
            )}
            {i < items.length - 1 && <i className="ri-arrow-right-s-line text-foreground-400"></i>}
          </li>
        ))}
      </ol>
    </nav>
  );
}